import * as React from "react"
import { classNames } from "../../../../utils/classNames"
import { HorizontalTabs, HorizontalTabsProps } from "../../HorizontalTabs/HorizontalTabs"

export type ModalHeaderProps<HorizontalTabsType> = {
    title?: string
    subtitle?: string
    tabs?: HorizontalTabsProps<HorizontalTabsType>
}
export const ModalHeader = <HorizontalTabsType extends string>(props: ModalHeaderProps<HorizontalTabsType>) => {
    const hasTabs = !!props.tabs
    return (
        <div>
            <div className={classNames(hasTabs ? classes.wrapWithTabs : classes.wrap)}>
                {props.subtitle ? <div className={classes.subtitle}>{props.subtitle}</div> : null}
                {props.title ? <div className={classes.title}>{props.title}</div> : null}
            </div>
            {props.tabs ? (
                <HorizontalTabs
                    className={classNames(classes.tabs, props.tabs.className)}
                    tabs={props.tabs.tabs}
                    value={props.tabs.value}
                    onChange={props.tabs.onChange}
                />
            ) : (
                <div className={classes.separator} />
            )}
        </div>
    )
}

const classes = {
    wrap: "px-4 md:px-10 pt-7 pb-5",
    wrapWithTabs: "px-4 md:px-10 pt-8 pb-6",
    separator: "border-b border-solid border-gray-200",
    subtitle: "text-14 -mb-0.5",
    title: "text-22 font-bold",
    tabs: "mb-2 px-4 md:px-10",
}
